import type { ProjectStatus } from "@/lib/types";

interface Props {
  status: ProjectStatus;
  size?: "sm" | "md";
}

const COLORS: Record<ProjectStatus, { bg: string; fg: string; label: string }> = {
  draft:         { bg: "#3a4555", fg: "#9aa5b5", label: "Draft" },
  quoted:        { bg: "#3d4a3d", fg: "#a6c7a6", label: "Quoted" },
  approved:      { bg: "#3a4f6b", fg: "#9ec0e8", label: "Approved" },
  in_production: { bg: "#6b4f2c", fg: "#e8c89e", label: "In production" },
  shipped:       { bg: "#4a3a5b", fg: "#c8aee8", label: "Shipped" },
  delivered:     { bg: "#2c5b3a", fg: "#9ee0a8", label: "Delivered" },
  cancelled:     { bg: "#5b2c2c", fg: "#e89e9e", label: "Cancelled" },
};

export function StatusBadge({ status, size = "md" }: Props) {
  const c = COLORS[status] ?? COLORS.draft;
  return (
    <span
      style={{
        display: "inline-block",
        padding: size === "sm" ? "1px 6px" : "2px 10px",
        borderRadius: 999,
        background: c.bg,
        color: c.fg,
        fontSize: size === "sm" ? 10 : 11,
        textTransform: "uppercase",
        letterSpacing: 0.5,
        fontWeight: 700,
        whiteSpace: "nowrap",
      }}
    >
      {c.label}
    </span>
  );
}

/** Allowed forward transitions (ignored if you want hard-edit). */
export const NEXT_STATUS: Record<ProjectStatus, ProjectStatus[]> = {
  draft:         ["quoted", "cancelled"],
  quoted:        ["approved", "draft", "cancelled"],
  approved:      ["in_production", "quoted", "cancelled"],
  in_production: ["shipped", "cancelled"],
  shipped:       ["delivered"],
  delivered:     [],
  cancelled:     ["draft"],
};
